var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("Copyright")]),_vm._v(" ©河南省卫生健康委员会 © 2021-"+_vm._s(_vm.year)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }